<script lang="ts">
	import RequiredMark from "@components/form/RequiredMark.svelte";
	import type { HTMLTextareaAttributes } from "svelte/elements";
	import { updateTextareaHeight } from "@core/utils/updateTextareaHeight.js";

	const {
		/** Renders the asterisk inside the field itself. Turn it off when a visible label already carries one. */
		requiredMark = true,
		...rest
	}: HTMLTextareaAttributes & { requiredMark?: boolean } = $props();

	const showRequiredMark = $derived(Boolean(rest.required) && requiredMark);
	const textareaClass = $derived([
		"min-w-0 block shadow-sm transition-[outline,color] duration-300 !outline-none border-[1.5px] resize-none",
		"text-cmctext placeholder:text-cmcmidgray font-semibold tracking-[0.02em] bg-white",
		"focus:border-cmcprimary min-h-6 md:min-h-12 rounded-lg md:rounded-xl border-cmcmidgray text-2xs/3 md:text-base/tight px-2 md:px-4 py-2 md:py-3.5",
		rest.class,
		showRequiredMark && "w-full !pr-7 md:!pr-9",
	]);
</script>

{#if showRequiredMark}
	<span class="relative block">
		<textarea use:updateTextareaHeight {...rest} class={textareaClass}></textarea>
		<span class="absolute top-2 md:top-3.5 right-2 md:right-3 pointer-events-none">
			<RequiredMark />
		</span>
	</span>
{:else}
	<textarea use:updateTextareaHeight {...rest} class={textareaClass}></textarea>
{/if}
